// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Published Videos Page Styles */

.published-videos-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

/* Header Styles */
.page-header {
  max-width: 1200px;
  margin: 0 auto 30px auto;
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.header-actions {
  margin-left: auto;
}

.back-button {
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.back-button:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.header-content h1 {
  margin: 0;
  font-size: 28px;
  color: #2c3e50;
  font-weight: 600;
}

.project-title {
  margin: 5px 0 0 0;
  font-size: 16px;
  color: #6c757d;
  font-style: italic;
}

/* Content Styles */
.page-content {
  max-width: 1200px;
  margin: 0 auto;
}

/* Loading Styles */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error Styles */
.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #f5c6cb;
  margin-bottom: 20px;
  text-align: center;
}

/* No Videos Styles */
.no-videos {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  margin-bottom: 30px;
}

.no-videos-icon {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.7;
}

.no-videos h2 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 24px;
}

.no-videos p {
  margin: 0 0 25px 0;
  color: #6c757d;
  font-size: 16px;
}

.deploy-button {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.deploy-button:hover {
  background: linear-gradient(135deg, #218838, #1ea080);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);
}

/* Add to Learning Button */
.add-to-learning-button {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: center;
}

.add-to-learning-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #0056b3, #004085);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.add-to-learning-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Progress Indicator */
.progress-indicator {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  margin: 0 auto 20px auto;
  max-width: 1200px;
  padding: 16px;
}

.progress-content {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
}

.progress-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.progress-content p {
  margin: 0;
  color: #856404;
  font-weight: 500;
}

/* Videos Grid */
.videos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

/* Video Card */
.video-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.video-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Video Thumbnail */
.video-thumbnail {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #f8f9fa;
}

.video-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 48px;
}

.language-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

/* Video Info */
.video-info {
  padding: 20px;
}

.video-title {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.video-description {
  margin: 0 0 16px 0;
  color: #6c757d;
  font-size: 14px;
  line-height: 1.5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* Video Meta */
.video-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.publish-date,
.video-id {
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Video Actions */
.video-actions {
  display: flex;
  gap: 12px;
}

.youtube-link {
  background: #ff0000;
  color: white;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.youtube-link:hover {
  background: #cc0000;
  transform: translateY(-1px);
  text-decoration: none;
  color: white;
}

/* Statistics */
.statistics {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  border: 1px solid #e9ecef;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
}

.stat-item {
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 768px) {
  .published-videos-page {
    padding: 15px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .header-actions {
    margin-left: 0;
    width: 100%;
  }

  .add-to-learning-button {
    width: 100%;
  }

  .header-content h1 {
    font-size: 24px;
  }

  .videos-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .stat-item {
    padding: 15px;
  }

  .stat-number {
    font-size: 24px;
  }

  .video-meta {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .video-card {
    border-radius: 8px;
  }

  .video-info {
    padding: 15px;
  }

  .video-title {
    font-size: 16px;
  }

  .video-actions {
    flex-direction: column;
  }

  .youtube-link {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/PublishedVideosPage.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,2BAA2B;AAC3B;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Published Videos Page Styles */\n\n.published-videos-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 20px;\n}\n\n/* Header Styles */\n.page-header {\n  max-width: 1200px;\n  margin: 0 auto 30px auto;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.header-actions {\n  margin-left: auto;\n}\n\n.back-button {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.back-button:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n}\n\n.header-content h1 {\n  margin: 0;\n  font-size: 28px;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.project-title {\n  margin: 5px 0 0 0;\n  font-size: 16px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Content Styles */\n.page-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Loading Styles */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error Styles */\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 15px;\n  border-radius: 6px;\n  border: 1px solid #f5c6cb;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n/* No Videos Styles */\n.no-videos {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);\n  margin-bottom: 30px;\n}\n\n.no-videos-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n  opacity: 0.7;\n}\n\n.no-videos h2 {\n  margin: 0 0 10px 0;\n  color: #2c3e50;\n  font-size: 24px;\n}\n\n.no-videos p {\n  margin: 0 0 25px 0;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n.deploy-button {\n  background: linear-gradient(135deg, #28a745, #20c997);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.deploy-button:hover {\n  background: linear-gradient(135deg, #218838, #1ea080);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(40, 167, 69, 0.3);\n}\n\n/* Add to Learning Button */\n.add-to-learning-button {\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 160px;\n  justify-content: center;\n}\n\n.add-to-learning-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0056b3, #004085);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\n}\n\n.add-to-learning-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Progress Indicator */\n.progress-indicator {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 8px;\n  margin: 0 auto 20px auto;\n  max-width: 1200px;\n  padding: 16px;\n}\n\n.progress-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: center;\n}\n\n.progress-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.progress-content p {\n  margin: 0;\n  color: #856404;\n  font-weight: 500;\n}\n\n/* Videos Grid */\n.videos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n/* Video Card */\n.video-card {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);\n  transition: all 0.3s ease;\n  border: 1px solid #e9ecef;\n}\n\n.video-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Video Thumbnail */\n.video-thumbnail {\n  position: relative;\n  width: 100%;\n  height: 200px;\n  overflow: hidden;\n  background: #f8f9fa;\n}\n\n.video-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.thumbnail-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  font-size: 48px;\n}\n\n.language-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Video Info */\n.video-info {\n  padding: 20px;\n}\n\n.video-title {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n  line-height: 1.4;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.video-description {\n  margin: 0 0 16px 0;\n  color: #6c757d;\n  font-size: 14px;\n  line-height: 1.5;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n/* Video Meta */\n.video-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.publish-date,\n.video-id {\n  font-size: 12px;\n  color: #6c757d;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Video Actions */\n.video-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.youtube-link {\n  background: #ff0000;\n  color: white;\n  text-decoration: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.youtube-link:hover {\n  background: #cc0000;\n  transform: translateY(-1px);\n  text-decoration: none;\n  color: white;\n}\n\n/* Statistics */\n.statistics {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);\n  border: 1px solid #e9ecef;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 30px;\n}\n\n.stat-item {\n  text-align: center;\n  padding: 20px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.stat-number {\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.stat-label {\n  font-size: 14px;\n  opacity: 0.9;\n  font-weight: 500;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .published-videos-page {\n    padding: 15px;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .header-actions {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .add-to-learning-button {\n    width: 100%;\n  }\n\n  .header-content h1 {\n    font-size: 24px;\n  }\n\n  .videos-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .stat-item {\n    padding: 15px;\n  }\n\n  .stat-number {\n    font-size: 24px;\n  }\n\n  .video-meta {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-card {\n    border-radius: 8px;\n  }\n\n  .video-info {\n    padding: 15px;\n  }\n\n  .video-title {\n    font-size: 16px;\n  }\n\n  .video-actions {\n    flex-direction: column;\n  }\n\n  .youtube-link {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
